module.exports = __webpack_public_path__ + "static/media/ESMplus.3bd56265.png";